import { createSlice } from '@reduxjs/toolkit';

import { ProjectClass } from '@/types/projectClass';
import * as asyncActions from './asyncActions';

type State = {
  bundled: ProjectClass[];
  gls: ProjectClass[];
};

const initialState: State = {
  bundled: [],
  gls: [],
};

const slice = createSlice({
  name: 'organization-projectClass',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      asyncActions.fetchBundledList.fulfilled,
      (state, action) => {
        state.bundled = action.payload;
      },
    );
  },
});

export const actions = slice.actions;
export default slice.reducer;
